import Browser from './browser';
import { cleanUp } from './functions';

const Print = {
  send: (params, printFrame) => {
    // Append iframe element to document body
    document.getElementsByTagName('body')[0].appendChild(printFrame);

    // Get iframe element
    const iframeElement = document.getElementById(params.frameId);

    // Wait for iframe to load all content
    iframeElement.onload = () => {
      if (params.type === 'pdf') {
        if (Browser.isFirefox() && Browser.getFirefoxMajorVersion() < 110) {
          setTimeout(() => performPrint(iframeElement, params), 2000);
        } else {
          performPrint(iframeElement, params);
        }
        return;
      }

      // Get iframe element document
      let printDocument = iframeElement.contentWindow || iframeElement.contentDocument;
      if (printDocument.document) {
        printDocument = printDocument.document;
      }

      // Append printable element to the iframe body
      printDocument.body.appendChild(params.printableElement);

      performPrint(iframeElement, params);
    };
  },
};

function performPrint(iframeElement, params) {
  try {
    iframeElement.focus();

    // If Edge or IE, try catch with execCommand
    if (Browser.isEdge() || Browser.isIE()) {
      try {
        iframeElement.contentWindow.document.execCommand('print', false, null);
      } catch (e) {
        iframeElement.contentWindow.print();
      }
    } else {
      // Other browsers
      iframeElement.contentWindow.print();
    }
  } catch (error) {
    params.onError(error);
  } finally {
    if (Browser.isFirefox() && Browser.getFirefoxMajorVersion() < 110) {
      // Move the iframe element off-screen and make it invisible
      iframeElement.style.visibility = 'hidden';
      iframeElement.style.left = '-1px';
    }

    cleanUp(params);
  }
}

export default Print;
